import React, { useEffect, useState, useContext } from "react";
import sendRequest from "hooks/useAxios";
import { showSwalSuccess, showSwalError } from "utils/swal";
import Modal from "react-bootstrap/Modal";
import { useParams } from "react-router-dom";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import toast from "react-hot-toast";
import toastFunction from "utils/toast";
import logo1 from "assets/images/sitelogo.svg";

const EditShopInfoModal = ({
  data,
  shopInfoUpdater,
  setShopInfoUpdater,
  adminId,
  type,
}) => {
  const auth = useContext(WithAuthentication);
  const [show, setShow] = useState(false);
  const [shopInfo, setShopInfo] = useState({});
  const [logo, setlogo] = useState("");
  const [cover, setcover] = useState("");
  const [shopInfoinput, setShopInfoinput] = useState({
    shopname: "",
    instagramaddress: "",
    whatsappaddress: "",
    address: "",
    rate: "",
  });

  // const [shopInfoUpdater, setShopInfoUpdater] = useState(false);
  let bId = useParams();
  useEffect(() => {
    if (show === true) {
      setShopInfo(data);
    }
    // console.log("data in edit shop info", shopInfo);
  }, [data, show]);

  const EditInfo = (businessesId, updateValue, logo, cover) => {
    console.log("update value : ", updateValue);
    sendRequest("edit_shop_info", {
      businessesId: bId.businessId,
      updateValue: `title,${updateValue.shopname}@@address,${updateValue.address}@@whatsapp,${updateValue.whatsappaddress}@@instagram,${updateValue.instagramaddress}`,
      coverfile: cover,
      logofile: logo,
    }).then(({ data }) => {
      if (data.status === 1) {
        // showSwalSuccess(
        toastFunction("success", "عملیات با موفقیت انجام شد.");

        setShopInfoUpdater((prev) => {
          return !prev;
        });
      } else {
        // showSwalError(
        toastFunction("error", "لطفا دوباره تلاش کنید.");
      }
    });
  };
  return (
    <>
      {auth.isLogged && auth.userInfo.id == adminId && type == 1 && (
        <button
          className="  col-lg-2 mx-1 col-sm-3 col-5 py-2 rounded my-1 adminBtn shadow"
          onClick={() => setShow(true)}
        >
          ویرایش فروشگاه
        </button>
        // <button
        //   type="button"
        //   class="btn btn-primary mt-3"
        //   onClick={() => setShow(true)}
        // >
        //   ویرایش
        // </button>
      )}
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>ویرایش اطلاعات فروشگاه</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div class="mb-3">
              <label for="formFile" class="form-label">
                عکس کاور:{" "}
              </label>
              <input
                onChange={(e) => {
                  // setcover(prev => {
                  //   return {
                  //     ...prev,
                  //     cover: e.target.files[0]
                  //   };
                  // });
                  setcover(e.target.files[0]);
                  console.log("cover is ", cover);
                }}
                class="form-control"
                type="file"
                id="formFile"
              />
            </div>
            <div class="mb-3">
              <label for="formFile2" class="form-label">
                عکس لوگو:
              </label>
              <input
                onChange={(e) => {
                  // setlogo(prev => {
                  //   return {
                  //     ...prev,
                  //     logo: e.target.files[0]
                  //   };
                  // });
                  setlogo(e.target.files[0]);
                }}
                class="form-control"
                type="file"
                id="formFile2"
              />
            </div>
            <div class="input-group mb-3">
              <label for="formname" class="form-label w-100">
                نام فروشگاه
                <input
                  id="formname"
                  value={shopInfo.shopname}
                  onChange={(e) => {
                    setShopInfo((prev) => {
                      return {
                        ...prev,
                        shopname: e.target.value,
                      };
                    });
                  }}
                  type="text"
                  class="form-control "
                  // placeholder="نام فروشگاه"
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                />
              </label>
            </div>
            <div class="input-group mb-3">
              <label for="form_address" class="form-label w-100">
                آدرس
                <textarea
                  id="form_address"
                  value={shopInfo.address}
                  type="text"
                  class="form-control w-100"
                  // placeholder="آدرس"
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  onChange={(e) => {
                    setShopInfo((prev) => {
                      return {
                        ...prev,
                        address: e.target.value,
                      };
                    });
                  }}
                />
              </label>
            </div>
            <div class="input-group mb-3">
              <label for="form_instagram" class="form-label w-100">
                اینستاگرام
                <input
                  id="form_instagram"
                  value={shopInfo.instagramaddress}
                  type="text"
                  class="form-control w-100"
                  // placeholder="اینستاگرام"
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  onChange={(e) => {
                    setShopInfo((prev) => {
                      return {
                        ...prev,
                        instagramaddress: e.target.value,
                      };
                    });
                  }}
                />
              </label>
            </div>
            <div class="input-group mb-3">
              <label for="form_whatsapp" class="form-label w-100">
                شماره واتساپ
                <input
                  id="form_whatsapp"
                  value={shopInfo.whatsappaddress}
                  type="text"
                  class="form-control w-100"
                  // placeholder="واتساپ"
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  onChange={(e) => {
                    setShopInfo((prev) => {
                      return {
                        ...prev,
                        whatsappaddress: e.target.value,
                      };
                    });
                  }}
                />
              </label>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            class="btn btn-secondary"
            // data-bs-dismiss="modal"
            onClick={() => {
              setShow(false);
            }}
          >
            لغو
          </button>
          <button
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              EditInfo(1, shopInfo, logo, cover);
            }}
            type="button"
            class="btn btn-primary"
          >
            ثبت
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default EditShopInfoModal;
